import React from 'react';
import {
    ActivityIndicator,
    TextStyle,
    TouchableHighlight,
    TouchableOpacity,
    View,
    ViewStyle,
} from 'react-native';
import { THEME_COLORS } from '../../theme/constants/themeColors';
import { THEME_STYLES } from '../../theme/constants/themeStyles';
import { COLORS } from '../../config/colors';
import CText from '../../ui/components/CText';

type Props = {
    title?: string;
    style?: ViewStyle;
    buttonStyle?: ViewStyle;
    /**
     * @deprecated Use `disabled` instead
     */
    disable?: boolean;
    disabled?: boolean;
    onPress?: () => void;
    icon?: () => void;
    rightIcon?: () => void;
    bordered?: boolean;
    height?: number;
    shadow?: boolean;
    titleSize?: number;
    textStyle?: TextStyle;
    loading?: boolean;
    loadingText?: string;
    backgroundColor?: string;
    underlayColor?: string;
};
export default function PrimaryButton(props: Props) {
    const {
        title,
        style,
        buttonStyle = {},
        disable,
        disabled,
        onPress = () => {},
        icon = () => {},
        rightIcon = () => {},
        bordered,
        height = 52,
        shadow,
        titleSize = 12,
        textStyle = {},
        loading,
        loadingText = '',
        backgroundColor = THEME_COLORS.buttonBgColor,
        underlayColor = THEME_COLORS.cardUnderlayBgColor,
    } = props;

    return (
        <View style={style}>
            <TouchableHighlight
                disabled={disable || disabled || loading}
                activeOpacity={0.7}
                style={[
                    {
                        backgroundColor: backgroundColor,
                        borderRadius: THEME_STYLES.buttonStyle.borderRadius,
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: height,
                        flexDirection: 'row',
                        // ...(shadow ? THEME_STYLES.shadow : {}),
                        opacity: disable || disabled || loading ? 0.7 : 1,
                        ...buttonStyle,
                    },
                ]}
                onPress={onPress}
                underlayColor={underlayColor}>
                <>
                    {/* loader and icon */}
                    {loading ? (
                        <View
                            style={{
                                marginRight: !!loadingText ? 5 : 0,
                            }}>
                            <ActivityIndicator
                                size={22}
                                color={
                                    bordered
                                        ? COLORS.blackColor
                                        : COLORS.whiteColor
                                }
                            />
                        </View>
                    ) : (
                        <>{icon()}</>
                    )}

                    {/* text */}
                    {(!loading || (loading && !!loadingText)) && (
                        <CText
                            value={loading ? loadingText : title}
                            size={titleSize}
                            semiBold
                            style={{
                                color: bordered
                                    ? THEME_COLORS.primaryColor
                                    : COLORS.whiteColor,
                                // marginTop: isIOS() ? 1 : 1,
                                ...textStyle,
                            }}
                        />
                    )}

                    <>{!loading && rightIcon()}</>
                </>
            </TouchableHighlight>
        </View>
    );
}
